module.exports = __webpack_public_path__ + "img/mpascensores-full.42569c47.png";